import { flatternRoutes } from 'ducks/utils'
import * as ducks from './ducks'

export default flatternRoutes(ducks)
